// Generated by ts-to-zod
import {z} from "zod";
import {mantineFlexWrapSchema} from "./primitives.zod";
import {mantineSpacingSchema} from "./spacing.zod";

export const mantineFlexPropsSchema = z.strictObject({
	justify: z.string().optional(),
	align: z.string().optional(),
	gap: mantineSpacingSchema.optional(),
	wrap: mantineFlexWrapSchema.optional(),
});
